import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { AppStoreState, INITIAL_APP_STORE_STATE } from '@navstation-portal/reporting/data-model/app';
import { signalStoreFeature, type } from '@ngrx/signals';
import { on } from '@ngrx/signals/events';
import { appEvents } from './app-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withAppReducer<_>() {
  return signalStoreFeature(
    type<{ state: AppStoreState }>(),
    withTrackedReducer(
      on(appEvents.setSelectedVesselId, ({ payload: selectedVesselId }) => ({
        selectedVesselId,
      })),
      on(appEvents.setDefaultVesselId, ({ payload: defaultVesselId }) => ({
        defaultVesselId,
      })),
      on(appEvents.setSelectedVessel, ({ payload: selectedVessel }) => ({
        selectedVessel,
      })),
      on(appEvents.setLoadingFullOverlay, ({ payload: isLoadingFullOverlay }) => ({
        isLoadingFullOverlay,
      })),
      on(appEvents.reset, () => ({
        ...INITIAL_APP_STORE_STATE,
      }))
    )
  );
}
